import { render, staticRenderFns } from "./GlassDetails.vue?vue&type=template&id=7637f0f5&scoped=true&"
import script from "./GlassDetails.vue?vue&type=script&lang=js&"
export * from "./GlassDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637f0f5",
  null
  
)

export default component.exports